import Vue, { PluginObject } from 'vue';
import VueRouter from 'vue-router';
import {Home} from './views/home';
import {MapComponent} from './components/map/map';

// Add routes
const RouterConfig = {
  routes: [
    { name: '', path: '/:view?', component: MapComponent },
    { name: 'map', path: '/:view?', component: MapComponent },
  ]
};

const router = new VueRouter(RouterConfig);
Vue.use(VueRouter);

export default router;



// WEBPACK FOOTER //
// src/routes.ts